import { createAction, props } from '@ngrx/store';

export const initiateOnboardingPaperlessEnrollment = createAction(
  '[onboarding-paperless-enrollment] Initiate',
  props<{ correlationId: string }>()
);
export const completeOnboardingPaperlessEnrollment = createAction(
  '[onboarding-paperless-enrollment] Complete'
);
